import { gql } from '@apollo/client';

export const START_BUSINESS_USER_VALIDATION = gql`
  mutation StartBusinessUserValidation($bankingInfo: BankingInfoInput!) {
    startBusinessUserValidation(bankingInfo: $bankingInfo) {
      id
    }
  }
`;
